import { ApiPalletDto } from '../../../api/elite/dto/pallet.dto';

type PackingBox = ApiPalletDto['infoToDisplay']['return']['boxes'][0];
export class GroupedPropertiesPackingBox implements PackingBox {
  partNumber: string;
  workOrder: string;
  salesOrder: string;

  boxes: {
    id: number;
    createdAt: string;
    quantity: number;
  }[] = [];

  get totalQuantity(): number {
    return this.boxes.reduce((acc, box) => acc + box.quantity, 0);
  }
  get totalBoxes(): number {
    return this.boxes.length;
  }

  constructor(data: PackingBox) {
    this.partNumber = data.partNumber;
    this.salesOrder = data.salesOrder || 'Stock';
    this.workOrder = data.workOrder;
    this.boxes = data.boxes;
  }
}
